import { Observable } from 'rxjs';

export class CrudTestErrorService {
  static getTestError<T>(endpoint: string, method: string): Observable<T> {
    return null;
  }
}
